import React from "react";
import { Container, NavbarBrand } from "reactstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const LandingFooter = () => {
  const history = useHistory();

  function getCurrentYear() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    return currentYear;
  }
  return (
    <div className="copyright-area px-3 bg-white">
      <Container fluid>
        <div className="row mx-0 align-items-center text-center text-xl-left">
          <div className="col-xl-2 col-lg-12 col-md-12 mb-2 mb-lg-0 px-0">
            <NavbarBrand href="/">
              <h1 className="nav_brand m-0" style={{ color: "#e54d6b" }}>
                NextEats
              </h1>
            </NavbarBrand>
          </div>

          <div className="col-xl-6 col-lg-12 col-md-12 mb-2 mb-lg-0 text-xl-start px-0">
            <div className="footer-menu">
              <ul className="list-inline m-0">
                <li className="list-inline-item ml-0">
                  <a href="mailto:support@nexteats.com">support@nexteats.com</a>
                </li>
                <li className="list-inline-item">
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    Privacy
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    Policy
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href="#"
                    className="cursor-pointer"
                    onClick={() => history.push("/contact")}
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-xl-4 col-lg-12 col-md-12  text-center text-xl-right px-0">
            <div className="copyright-text">
              <p className="m-0 small">
                Copyright &copy; {getCurrentYear()} NextEats, All Rights
                Reserved
              </p>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default LandingFooter;
